import {
  tag_colorTagSevereText,
  text_colorTextPrimary,
  text_colorTextSecondary,
  text_colorTextSuccess,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(5)};
  width: 100%;

  .managerReviewSection-summary,
  .managerReviewSection-summary-details,
  .managerReviewSection-status,
  .managerReviewSection-manager {
    display: flex;
    align-items: center;
  }

  .managerReviewSection-summary {
    justify-content: space-between;
    gap: ${spacing(5)};
    width: 100%;
  }

  .managerReviewSection-summary-details {
    justify-content: flex-end;
    gap: ${spacing(4)};
  }

  .managerReviewSection-status,
  .managerReviewSection-manager {
    gap: ${spacing(2)};
    white-space: nowrap;
  }

  .managerReviewSection-status {
    color: ${text_colorTextSecondary};
    font-family: ${font_family_weight_regular};
    ${font_sm}
  }

  .managerReviewSection-status-reviewed,
  .managerReviewSection-status-auto-reviewed {
    color: ${text_colorTextSuccess};
  }

  .managerReviewSection-status-rejected {
    color: ${tag_colorTagSevereText};
  }

  .managerReviewSection-manager {
    color: ${text_colorTextPrimary};
    font-family: ${font_family_weight_regular};
    font-weight: 400;
    ${font_md}
  }

  .managerReviewSection-avatar-initials {
    font-family: ${font_family_weight_regular};
    ${font_sm}
  }
`
